import * as React from "react";
import definitions from "../../data/definitons.json";
import data from "../../data/info.json";
import { McuView } from "./McuView";
import { ExtView } from "./ExtView";
import { Data } from "../../data/types";
import { deviceType } from "../../components/Helper";

export const AdvancedView = (props: any) => {
    const info: Data = data;
    const dType: any = deviceType;
    const mcuVersion = props?.mcuVersion;
    const [exts, setExt] = React.useState<string[]>([])
    const [alt, setAlt] = React.useState<boolean>(false);
    const colors = ["bg-primary", "bg-secondary"]
    const isAdvancedView = props?.type !== Object.keys(deviceType)[0];
    React.useEffect(() => {
        //collect and modify the total number of extenstions
        const keys = Object.keys(info["extensions"][props?.ext] ?? {});
        const temp = keys;
        if (keys?.length > 0) { if (keys?.length === 1) { temp.push("EXT2"); setAlt(true) } }
        setExt(temp)
    }, [props?.ext])

    return <div className="w-100 h-100">
        <div className="mt-1">
            Visual Representation of {dType[props?.type]} Boards Pin Outs {!isAdvancedView ? "→ CNano Touch Adapter" : ""} → Touch Extension Boards.
        </div>
        <div className="content w-100 h-100">
            <McuView type={props?.type} data={data} defs={definitions} mcu={props?.mcu} ext={props?.ext} isAdvancedView={isAdvancedView} mcuVersion={mcuVersion} />
            <div className="adv-view-content">
                {
                    exts?.map((ext, i) => {
                        if (i === 0)
                            return <div className="w-100">
                                <div className="w-100 ext-msg mb-1">
                                    Options If Connected to {exts[i]}
                                </div>
                                <ExtView type={props?.type} data={data} defs={definitions} mcu={props?.mcu}  mcuVersion={mcuVersion} extension={props?.ext} ext={ext} color={colors[i]} />
                            </div>

                        return <div className="w-100">
                            {alt ? <div className="w-100 ext-msg mb-1">
                                Alternative Options If Connected to {exts[i]}
                            </div> : <div className="w-100 ext-msg mb-1">
                                Options If Connected to {exts[i]}
                            </div>}
                            <ExtView type={props?.type} data={data} defs={definitions} mcu={props?.mcu} mcuVersion={mcuVersion} extension={props?.ext} ext={ext} color={colors[i]} />
                        </div>
                    })
                }
            </div>
        </div>
    </div >
}